type FollowUp = 'none' | 'care_team_review' | 'urgent';

const STYLES: Record<Exclude<FollowUp, 'none'>, { label: string; cls: string }> = {
  care_team_review: { label: 'Care team review', cls: 'bg-hs-warning-soft text-hs-warning-text' },
  urgent: { label: 'Urgent', cls: 'bg-hs-danger-soft text-hs-danger-text' },
};

export function FollowUpBadge({ value }: { value: FollowUp }) {
  if (value === 'none') return null;
  const s = STYLES[value];
  return (
    <span className={`inline-flex items-center rounded-hs-pill px-2.5 py-1 text-[11px] font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
}
